<template>
  <div v-if="dialogVisible" class="dialog-box">
    <div class="message-content-center">
      <div class="message-content-center-header-font">{{ dialogInfo.content }}</div>
      <div class="dialog-footer" v-if="!isTencent">
        <div class="sure-button" @click="sure">{{ dialogInfo.buttonText }}</div>
      </div>
    </div>

<!--    <el-dialog-->
<!--      class="dialog"-->
<!--      :visible.sync="dialogVisible"-->
<!--      :close-on-click-modal="false"-->
<!--      :close-on-press-escape="false"-->
<!--      width="30%"-->
<!--      :show-close="false"-->
<!--    >-->
<!--      &lt;!&ndash; <p class="content">{{$t('remoteLogin',{time:time})}}</p> &ndash;&gt;-->
<!--      <p class="content">{{ $t("remoteLogin") }}</p>-->
<!--      <span slot="footer" class="dialog-footer">-->
<!--      <el-button class="button" type="primary" @click="sure">{{-->
<!--          $t("sure")-->
<!--        }}</el-button>-->
<!--    </span>-->
<!--    </el-dialog>-->
  </div>

</template>

<script>
// import { mapMutations } from "vuex";
import {getSession} from "../../utils";

export default {
  // data() {
  //   return {
  //     dialogVisible: true,
  //   }
  // },

  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    time: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isTencent: !!getSession('txModuleId'), // 是否腾讯对接
    }
  },
  mounted() {},
  methods: {
    // ...mapMutations(['setRemoteLogin']),
    sure() {
      this.$emit("sure");
      // this.dialogVisible = false
      // this.setRemoteLogin(false)
    },
  },
};
</script>

<style lang='scss' scoped>
.dialog-box {
  height: 100%;
  width: 100%;
  background: rgba(0,0,0,0.6);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 50000;
  user-select: none;
}
.message-content-center {
  width: var(--width-489);
  height: var(--height-176);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: var(--padding-x-24);
  border-radius: var(--border-radius-6);
  border: var(--width-1) solid var(--color-gray-line-light);
  background: var(--color-white-base);
  box-shadow: 0 var(--margin-x-12) var(--margin-y-40) 0 rgba(0, 0, 0, 0.1);
  z-index: 50001;

  &-header-font {
    font-size: var(--font-size-h6);
    color: #1D2129;
    line-height: var(--font-line-height-m);
    font-weight: var(--font-weight-l);
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;

    @mixin button-default {
      height: var(--height-40);
      border-radius: var(--width-20);
      font-size: var(--font-size-m);
      line-height: var(--font-line-height-m);
      padding: var(--padding-y-8) var(--padding-x-16);
      cursor: pointer;
      text-align: center;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .sure-button{
      @include button-default;
      background: var(--color-blue-active);
      color: var(--color-white-base);
    }
  }
  //&-header {
  //  display: flex;
  //  align-content: center;
  //  align-items: center;
  //}
  //&-content {
  //  font-size: var(--font-size-m);
  //  color: #1D2129;
  //  margin-top: var(--margin-y-16);
  //  line-height: var(--font-line-height-s);
  //}
}
//.dialog {
//  display: flex;
//  flex-direction: column;
//  justify-content: center;
//  align-items: center;
//  border-radius: 0.625rem;
//  width: auto;
//}
//.content {
//  // margin-left: 0.125rem;
//  // margin-right: 0.125rem;
//  // margin-bottom: 0.0625rem;
//  font-size: 0.1375rem;
//  line-height: 0.25rem;
//  // color: rgba($color: #0c121c, $alpha: 0.6);
//  color: #2e2e2e;
//  // font-size: 500;
//  // margin-top: 0.06875rem;
//  // min-width: 2.5rem;
//  font-weight: bold;
//  text-align: center;
//}
//.button {
//  width: 0.9375rem;
//  margin-bottom: 0.125rem;
//  border-radius: 0.15rem;
//}
///deep/ .el-dialog__footer {
//  display: flex;
//  flex-direction: row;
//  justify-content: center;
//}
</style>



// WEBPACK FOOTER //
// src/components/common/remoteLoginDialog.vue